import { ScanLine, AlertTriangle } from "lucide-react";

export const DocCheckResult = ({ check }) => {
  if (!check) return null;
  const ok = check.status === "recognized";
  const facts = [
    ["Documento", check.document_label],
    ["N. licenza", check.license_number],
    ["Comune", check.municipality],
    ["Intestatario", check.holder_name],
    ["Targa", check.plate],
  ].filter(([, v]) => v);
  return (
    <div data-testid="profile-doc-check" data-status={check.status} className={`rounded-xl border p-4 flex flex-col gap-2 ${ok ? "border-[#10B981]/40 bg-[#10B981]/10" : "border-amber-500/40 bg-amber-500/10"}`}>
      <span className={`flex items-center gap-2 font-bold ${ok ? "text-[#10B981]" : "text-amber-400"}`}>
        {ok ? <ScanLine size={18} /> : <AlertTriangle size={18} />} {ok ? "Dati riconosciuti automaticamente" : "Documento non verificato"}
      </span>
      {facts.map(([k, v]) => (
        <span key={k} className="flex justify-between gap-3 text-sm"><span className="text-[#94A3B8]">{k}</span><span className="text-white font-semibold text-right">{v}</span></span>
      ))}
      {!ok && <span data-testid="profile-doc-check-reason" className="text-sm text-white">{check.reason}</span>}
    </div>
  );
};
